export default __webpack_public_path__ + "static/media/apple-black.a69e6fc8.webp";